import React from 'react';
import { IonPage, IonContent} from '@ionic/react';
import MemberShipCard from "../components/MemberShipCard";

export default function MembershipDesktopPage({withoutLogin,renderHeaderPage}) {

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent
                fullscreen
                className="membership-content page-content"
            >
                <div className="desktop-contain-membership">
                    <MemberShipCard withoutLogin={withoutLogin}/>
                </div>
            </IonContent>
        </IonPage>
    );
}
